import api from './api';
import { API_URL } from './base';

export const getShippingDetails = tracking_no => {
    return api.get(`${API_URL}/admin/tracking-details/${tracking_no}/`).then(resp => {
        return resp.data;
    });
};